import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import SEO from '../components/SEO';
import { generateFAQSchema } from '../utils/schema';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const FAQ = () => {
  const [faqs, setFaqs] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/api/faqs`)
      .then(res => setFaqs(res.data))
      .catch(err => console.error('Error:', err));
  }, []);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <SEO 
        title="Pest Control FAQ - Common Questions Answered"
        description="Get answers to frequently asked questions about pest control services in Queens & NYC. Learn about treatments, pricing, safety, and more. Call (646) 209-9955!"
        keywords="pest control FAQ, exterminator questions, pest control pricing, safe pest control, pest treatment questions"
        schema={faqs.length > 0 ? generateFAQSchema(faqs) : null}
      />
      <section className="bg-gradient-to-r from-blue-600 to-green-600 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Frequently Asked Questions</h1>
          <p className="text-xl">Find answers to common questions about our pest control services</p>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={faq.id} className="bg-white rounded-lg shadow-lg overflow-hidden">
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition"
                >
                  <span className="font-bold text-lg text-gray-900">{faq.question}</span>
                  <svg 
                    className={`w-6 h-6 transform transition-transform ${openIndex === index ? 'rotate-180' : ''}`}
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-4 text-gray-700">
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-12 bg-blue-50 p-8 rounded-lg text-center">
            <h2 className="text-2xl font-bold mb-4">Still Have Questions?</h2>
            <p className="text-gray-700 mb-6">Can&apos;t find what you&apos;re looking for? Contact us and we&apos;ll be happy to help!</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="tel:6462099955" className="bg-green-600 text-white px-8 py-3 rounded-lg font-bold hover:bg-green-700 transition">Call (646) 209-9955</a>
              <Link to="/contact" className="bg-blue-600 text-white px-8 py-3 rounded-lg font-bold hover:bg-blue-700 transition">Contact Us</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;